import { Empty } from 'antd';

import {useTranslation} from "react-i18next";

export const EmptyComponent = ({ decription = 'noDataText'}) => {
	const { t } = useTranslation()
	return <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={t(decription)} />;
};
